export const requestNotificationPermission = () => window.Notification?.requestPermission?.();
